export default "__VITE_ASSET__UOqUDbf___"